var _path, _path2, _line;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFVentre1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 87,
    height: 178,
    viewBox: "0 0 87 178",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M74.3311 0.249512C78.3501 17.398 74.053 35.4138 69.511 53.615C66.6043 65.3872 63.5785 77.2256 62.6516 88.9647C60.023 121.719 84.2825 145.608 85.8252 177.25",
    stroke: "#909090",
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.3162 0.249512C17.0262 11.1742 11.0209 20.3907 5.77043 30.3752C3.76426 34.2684 0.500014 39.9757 0.500014 46.0273C0.500014 57.5629 11.4535 63.9769 11.0673 69.7703C10.8311 75.7633 9.90363 81.3001 9.90363 85.3455C9.90363 99.6197 10.7494 124.905 10.7494 135.319C10.7494 145.732 12.4907 165.921 11.6829 177.197",
    stroke: "#909090",
    strokeMiterlimit: 10
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 1.70795,
    y1: 91.0547,
    x2: 1.70794,
    y2: 153.954,
    stroke: "#909090",
    strokeDasharray: "3.89 3.89"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFVentre1);
export default __webpack_public_path__ + "static/media/F-VENTRE_1.4f1d2374a50872ed4e36085f4e9ad028.svg";
export { ForwardRef as ReactComponent };